import InstagramSettings from './InstagramSettings';

export default InstagramSettings;
